import {Alert, Box, Button, Card, CardContent, Container, Dialog, Typography, useTheme} from "@mui/material";
import LogoA from "@/assets/logo_black.svg";
import {useSearchParams} from "react-router-dom";
import {useAuth0} from "@auth0/auth0-react";
import {LoadingCard} from "@/components/LoadingCard.tsx";

export function LoginPage() {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description');
  const {loginWithRedirect, isLoading} = useAuth0();
  
  return <>
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: 'background.default',
      }}
    >
      <Dialog open={isLoading} fullWidth maxWidth="xs">
        <Box sx={{
          overflow: 'hidden',
        }}>
          
          <LoadingCard/>
        </Box>
      </Dialog>
      {error && (
        <Container maxWidth="sm" sx={{mb: 3}}>
          <Alert severity="error" sx={{mb: 2}}>
            {errorDescription ? decodeURIComponent(errorDescription) : error}
          </Alert>
        </Container>
      )}
      <Container maxWidth="sm">
        <Card
          variant="outlined"
          sx={{
            overflow: 'hidden',
            bgcolor: 'background.paper',
            borderColor: theme.palette.primary.main,
            borderWidth: 2,
          }}
        >
          <CardContent sx={{p: 4}}>
            <Box
              component="img"
              src={LogoA}
              sx={{
                width: 180,
                height: 'auto',
                display: 'block',
                margin: '0 auto 2rem',
                py: 5,
              }}
            />
            <Typography
              variant="h5"
              component="h1"
              textAlign="center"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                color: theme.palette.primary.main,
              }}
            >
              ようこそ
            </Typography>
            <Typography
              variant="body1"
              textAlign="center"
              color="text.secondary"
              sx={{mb: 4}}
            >
              続行するにはログインしてください
            </Typography>
            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={() => loginWithRedirect({
                appState: {
                  returnTo: window.location.pathname === '/login' ? '/' : window.location.pathname,
                }
              })}
              sx={{
                py: 1.5,
                textTransform: 'none',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: theme.palette.primary.dark,
                }
              }}
            >
              ログイン
            </Button>
            <Box sx={{mt: 2, textAlign: 'center'}}>
              <Typography
                component="a"
                href="https://ai-smart-zyusetu.paradis.ltd/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: theme.palette.primary.main,
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  }
                }}
              >
                製品ページはこちら
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  </>
}